import styled from 'styled-components';

const StyledText = styled.div.attrs((props) => ({
  as: props.as || 'h1', // Use 'h1' as the default tag or the value passed in props.as
}))`
  font-size: ${(props) => (props.as === 'h1' ? '22px' : '18px')};
  color: ${(props) => (props.color === 'white' ? '#fff' : '#000')};
  text-wrap: balance;
`;

export default StyledText;
